import API from './api';
import { isInstalled } from './usePush';

/**
 * track — the install-and-notification funnel, client side.
 *
 * One function, a closed list of events on the server, and no consequences if
 * it fails. Nothing in the app should ever wait on this or branch on its
 * result: a member's week does not depend on whether a counter went up.
 *
 * It exists to answer one question with numbers instead of argument — how many
 * people install the app, how many turn notifications on, and how many come
 * back when one arrives. Push sat live with zero subscribers for months and
 * nobody could see it.
 */

export function platform() {
  const ua = window.navigator.userAgent || '';
  const iOS = /iPad|iPhone|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  if (iOS) return 'ios';
  if (/Android/.test(ua)) return 'android';
  if (/Windows|Macintosh|X11|Linux/.test(ua)) return 'desktop';
  return 'other';
}

export default function track(event) {
  // Unauthenticated visitors have no user to attribute anything to, and the
  // endpoint would 401 — which the API interceptor would rather not see.
  if (!localStorage.getItem('nfl_token')) return;
  API.post('/events', { event, platform: platform() }).catch(() => {});
}

/**
 * Called once when the app boots. Installed and tab launches are separate
 * events rather than a flag, because "how many of our members have the app on
 * their home screen" is the number the whole question turns on.
 */
export function trackLaunch() {
  track(isInstalled() ? 'launch_installed' : 'launch');
}
